import { useState } from "react";
import { ActionIcon, Button, Group, Paper, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons";
import i18n from "../i18n";

const DiscountRateInfo = () => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <ActionIcon
        size="xs"
        variant="transparent"
        color="blue"
        aria-label="Discount Rate info"
        onClick={(event) => {
          event.stopPropagation();
          setOpened(true);
        }}
      >
        <IconInfoCircle size={14} />
      </ActionIcon>
      {opened && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="discount-rate-info-title"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 400,
            background: "rgba(0, 0, 0, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setOpened(false)}
        >
          <Paper
            p="lg"
            shadow="xl"
            radius="md"
            style={{ width: 480, maxWidth: "92vw" }}
            onClick={(event) => event.stopPropagation()}
          >
            <Stack spacing="sm">
              <Text id="discount-rate-info-title" weight={700}>
                {i18n.t("Discount Rate")}
              </Text>
              <Text size="sm">
                {i18n.t(
                  "A discount rate is optional. It is a second rate under the original gross rate, used for consultant commission."
                )}
              </Text>
              <Text size="sm">
                {i18n.t(
                  "Once a discount rate is saved, every year uses it, including 0. Commission dispatch and the rate shown to consultants use the discount rate. Insurer commission statement matching still uses the original rate."
                )}
              </Text>
              <Text size="sm">
                {i18n.t(
                  "A year set to 0 dispatches no consultant commission for that year. The difference between the original rate and the discount rate is added to the remain layer."
                )}
              </Text>
              <Group position="right">
                <Button onClick={() => setOpened(false)}>{i18n.t("Close")}</Button>
              </Group>
            </Stack>
          </Paper>
        </div>
      )}
    </>
  );
};

export default DiscountRateInfo;
